import api from "./api";

const getAppInfo = (slug, successCallback, failureCallback) => {
	api.get(
		"/appInfoWeb/" + slug,
		{ params: { type: "web" } },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getMenusAndProducts = (
	restaurantId,
	appId,
	successCallback,
	failureCallback
) => {
	api.get(
		"/getMenusProductsCategories/" + restaurantId + "?appId=" + appId,
		{},
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getMenuDetails = (menuId, successCallback, failureCallback) => {
	api.get(
		"/fullMenuInfos/" + menuId,
		{},
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getRestaurantInfos = (restaurantId, successCallback, failureCallback) => {
	api.get(
		"/restaurant/" + restaurantId,
		{},
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const saveOrder = (data, successCallback, failureCallback) => {
	api.post(
		"/order",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const payinWithMangopay = (data, successCallback, failureCallback) => {
	api.post(
		"/webPayInMangopay",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const checkPayment = (data, successCallback, failureCallback) => {
	api.get(
		"/checkWebPayment",
		{ params: data },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const checkPromo = (data, successCallback, failureCallback) => {
	api.post(
		"/validatePromocode",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const sendMail = (orderId) => {
	api.post(
		"/sendOrderMail",
		{
			orderId,
		},
		async (res) => {},
		(err) => {
			console.warn("payinWithMangopay err", err);
		}
	);
};

const isRestaurantOpen = (data, successCallback, failureCallback) => {
	api.post(
		"/isRestaurantOpenAtTime",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

// const createCardRegistration = async (
// 	data,
// 	successCallback,
// 	failureCallback
// ) => {
// 	return api.post(
// 		"/createWebCardRegistration",
// 		data,
// 		(res) => {
// 			return successCallback(res);
// 		},
// 		(err) => {
// 			return failureCallback(err);
// 		}
// 	);
// };
// const createWebCardPayment = async (data, successCallback, failureCallback) => {
// 	return api.post(
// 		"/createWebCardPayment",
// 		data,
// 		(res) => {
// 			return successCallback(res);
// 		},
// 		(err) => {
// 			return failureCallback(err);
// 		}
// 	);
// };

const services = {
	getAppInfo,
	getMenusAndProducts,
	getMenuDetails,
	getRestaurantInfos,
	saveOrder,
	checkPayment,
	payinWithMangopay,
	sendMail,
	checkPromo,
	isRestaurantOpen,
	// createCardRegistration,
	// createWebCardPayment,
};
export default services;
